import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onMounted, onUnmounted, ref } from 'vue';
import SiteButton from '@/elements/SiteButton.vue';
import utils from '@/utils';
import { SplitContentBannerProps } from '@/types/components/split-content-banner';
import PlasmidShapeBox from '@/sections/PlasmidShapeBox.vue';
import OverallSettings from '@/sections/overall-settings.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SplitContentBanner',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);
const sectionRef = ref<HTMLElement | null>(null);
const leftRef = ref<HTMLElement | null>(null);
const rightRef = ref<HTMLElement | null>(null);
const isLeftVisible = ref(false);
const isRightVisible = ref(false);

const buttons = computed<any[]>(() => {
  const list = utils.sc.getFieldObj(fields.value, 'buttons');
  return Array.isArray(list) ? list : [];
});

const helperLink = computed(() => {
  const link = utils.sc.getFieldObj(fields.value, 'helperLinkUrl')?.value || {};
  return {
    href: link.href || '#',
    target: link.target || '_self',
  };
});

const getButtonType = (button: any) => {
  const raw = String(utils.sc.getFieldValue(button, 'buttonType', 'primary') || '').toLowerCase();
  return raw === 'secondary' || raw === 'tertiary' ? raw : 'primary';
};

let leftObserver: IntersectionObserver | null = null;
let rightObserver: IntersectionObserver | null = null;

onMounted(() => {
  if (leftRef.value) {
    leftObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isLeftVisible.value = entry.isIntersecting;
        });
      },
      { threshold: 0.12 }
    );
    leftObserver.observe(leftRef.value);
  }

  if (rightRef.value) {
    rightObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isRightVisible.value = entry.isIntersecting;
        });
      },
      { threshold: 0.12 }
    );
    rightObserver.observe(rightRef.value);
  }
});

onUnmounted(() => {
  if (leftObserver) leftObserver.disconnect();
  if (rightObserver) rightObserver.disconnect();
});

return (_ctx: any,_cache: any) => {
  const _component_SiteLink = _resolveComponent("SiteLink")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (_openBlock(), _createBlock(OverallSettings, { fields: fields.value }, {
    default: _withCtx(() => [
      (fields.value)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            class: _normalizeClass(_ctx.$style['c-split-content-banner']),
            ref_key: "sectionRef",
            ref: sectionRef
          }, [
            _createVNode(_component_ContentGrid, {
              "desktop-default-grid": [2, 20],
              "mobile-default-grid": [1, 14]
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style['c-split-content-banner__inner'])
                }, [
                  _createElementVNode("div", {
                    ref_key: "leftRef",
                    ref: leftRef,
                    class: _normalizeClass([
              _ctx.$style['c-split-content-banner__left'],
              isLeftVisible.value && _ctx.$style['c-split-content-banner__left--revealed'],
            ])
                  }, [
                    _createElementVNode("h2", {
                      class: _normalizeClass(_ctx.$style['c-split-content-banner__title'])
                    }, _toDisplayString(_unref(utils).sc.getFieldValue(
                  fields.value,
                  'title',
                  'Ready to start your gene synthesis project?'
                )), 3),
                    _createElementVNode("p", {
                      class: _normalizeClass(_ctx.$style['c-split-content-banner__description'])
                    }, _toDisplayString(_unref(utils).sc.getFieldValue(
                  fields.value,
                  'description',
                  'Get an instant quote online, or talk to one of our gene synthesis specialists. Most quotes delivered same day.'
                )), 3),
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.$style['c-split-content-banner__buttons'])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttons.value, (button, index) => {
                        return (_openBlock(), _createBlock(SiteButton, _mergeProps({
                          key: button.id || `split-banner-button-${index}`
                        }, { ref_for: true }, button, { size: "small" }), null, 16))
                      }), 128))
                    ], 2),
                    _createElementVNode("p", {
                      class: _normalizeClass(_ctx.$style['c-split-content-banner__helper'])
                    }, [
                      _createTextVNode(_toDisplayString(_unref(utils).sc.getFieldValue(fields.value, 'helperPrefix', 'Returning customer?')) + " ", 1),
                      _createVNode(_component_SiteLink, {
                        link: _unref(utils).sc.getFieldObj(fields.value, 'helperLink')
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(utils).sc.getFieldValue(fields.value, 'helperLinkText', 'Reorder from history')), 1)
                        ]),
                        _: 1
                      }, 8, ["link"])
                    ], 2)
                  ], 2),
                  _createElementVNode("div", {
                    ref_key: "rightRef",
                    ref: rightRef,
                    class: _normalizeClass([
              _ctx.$style['c-split-content-banner__right'],
              isRightVisible.value && _ctx.$style['c-split-content-banner__right--revealed'],
            ]),
                    "aria-hidden": "true"
                  }, [
                    _createVNode(PlasmidShapeBox)
                  ], 2)
                ], 2)
              ]),
              _: 1
            })
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["fields"]))
}
}

})